<div mat-dialog-header>
  <h1>{{ headline }}</h1>
</div>
<mat-dialog-content #scroll class="dialog-container">
  <form [formGroup]="form">
    <mat-form-field class="col-12">
      <textarea
        matInput
        [formControlName]="'reason'"
        [placeholder]="'Copied Profile Description'"
        [required]="required"
      ></textarea>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    @if (selectLaunch) {
      <mat-form-field class="col-6">
        <mat-label>Launch To</mat-label>
        <mat-select [formControlName]="'launchto'" [required]="required">
          @for (redirect of redirects; track redirect) {
            <mat-option [value]="redirect.value">
              {{ redirect.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  <button type="button" mat-raised-button color="accent" (click)="save()">
    Copy
  </button>
  <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
